export function modalWindow() {
  const modalOpenTrigger = document.querySelectorAll('.c-button__modal');
  const modalCloseTrigger = document.querySelectorAll('.c-button__modal__close');

  if (!modalOpenTrigger) {
    return;
  }

  modalOpenTrigger.forEach((openButton) => {
    const dialog = document.querySelector(openButton.dataset.dialog);
    openButton.addEventListener('click', () => {
      dialog.showModal();
    });
  });

  modalCloseTrigger.forEach((closeButton) => {
    const dialog = closeButton.closest('dialog');
    closeButton.addEventListener('click', () => {
      dialog.close();
    });
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) {
        dialog.close();
      }
    });
  });
}
